/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_LockedInputs */

const en_model_locked = /** @type {(inputs: Model_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to unlock`)
};

const id_model_locked = /** @type {(inputs: Model_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade untuk membuka`)
};

/**
* | output |
* | --- |
* | "Upgrade to unlock" |
*
* @param {Model_LockedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_locked = /** @type {((inputs?: Model_LockedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_LockedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_locked(inputs)
	return en_model_locked(inputs)
});